import { ActionReducer, INIT, UPDATE } from '@ngrx/store';

import { AppState } from '@app/store/store.states';
import { AuthTokenService } from '@app/core/services/auth-token/auth-token.service';
import { parseUserPayload } from './auth.reducer';

export function initStateFromLocalStorage(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return (state, action) => {
    const newState = reducer(state, action);

    if ([INIT.toString(), UPDATE.toString()].includes(action.type)) {
      const authenticatedUser = new AuthTokenService().decodeAccessToken();

      if (authenticatedUser) {
        newState.auth.isAuthenticated = true;

        newState.auth.user = parseUserPayload(authenticatedUser);
      }
    }

    return newState;
  };
}
